import loadable from '@loadable/component';

export const Header = loadable(() => import('./Header/Header'));
export const Footer = loadable(() => import('./Footer/Footer'));
export const Body = loadable(() => import('./Body/Body'));
export const ReviewList = loadable(() => import('./ReviewList/ReviewList'));
